import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Credentials|Status|';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'CP',
	feature: HubFeature.Credential,
};

export type CertDetailLoc = 'CPCertDetailLabelVerificationId';

export const cpCertDetailLocs: LocDefs<CertDetailLoc> = {
	CPCertDetailLabelVerificationId: {
		defaultValue: 'Verification ID',
		displayType: 'Label',
		description: 'Label for the Verification ID field',
		displayPath: `${dpRoot}Verification ID`,
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CertDetailLoc>(cpCertDetailLocs);
